import { Dictionary } from "@insite/client-framework/Common/Types";
import isPlainObject from "lodash/isPlainObject";
import { useEffect } from "react";

const cleanupData = (data: any) => {
    if (isPlainObject(data)) {
        Object.entries(data).forEach(([key, value]) => {
            if (!value && typeof value !== "boolean") {
                delete data[key];
            } else {
                cleanupData(value);
            }
        });
    }
};

// Using the "Thing" and specially "WithContext" types from "schema-dts" causes massive performance loss
const useStructuredData = <T extends Dictionary<any> | undefined>(data: T | string) => {
    useEffect(() => {
        if (!data) {
            return;
        }

        let _data;
        let _structuredData;

        if (typeof data !== "string") {
            _data = { ...data };
            cleanupData(_data);
            _structuredData = JSON.stringify({
                "@context": "https://schema.org",
                ..._data,
            });
        } else {
            _structuredData = data;
        }

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = _structuredData;

        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [data]);
};

export default useStructuredData;
